import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { DateTimeStringFomat } from 'src/components/shared-components/enum/enumMisc';
import { DatePickerEmission } from 'src/model/interface/datePickeremission';

@Component({
    selector: 'app-form-date-picker-w-header',
    templateUrl: './form-date-picker-w-header.component.html',
    styleUrls: ['./form-date-picker-w-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormDatePickerWHeaderComponent implements OnInit {

  /**
 * Input property; if true, the inner date-picker.component shall include a "ion-datetime" element with "date" presentation.
 */
  @Input() isDate: boolean;

  /**
   * Input property; if true, the inner date-picker.component shall include a "ion-datetime" element with "time" presentation.
   */
  @Input() isTime: boolean;

  /**
   * Input property; this enum value specify the peculiar format in which  the "initDate" is expressed. If not specified, the default is  "YYYY-MM-DD".
   */
  @Input() formatDate: DateTimeStringFomat;

  /**
   * Input property; this enum value specify the peculiar format in which  the "initTime" is expressed. If not specified, the default is  "HH:mm".
   */
  @Input() formatTime: DateTimeStringFomat;

  /**
   *Input property; String-date used to initialise the inner date-picker.component.
   */
  @Input() initDate: string;

  /**
   * Input property; String-time used to initialise the inner date-picker.component.
   */
  @Input() initTime: string;

  /**
   * Input property; if set to true; the component shall also include a text-type input field through which the user shall be able to insert
   * date-strings and time-strings.
   */
  @Input() isInputFieldVisible: boolean;

  /**
   * Input property; String-date used to set the maximum value of the ion-datetime in the inner date-picker.component
   */
  @Input() maxDate: string;

  /**
   * Input property; String-date used to set the minimum value of the ion-datetime in the inner date-picker.component
   */
  @Input() minDate: string;

  /**
   * This event  emits a string, detailing the date/time selected in the component, to the father.
   * The strings shall be formatted following the same pattern as specified in "formatDate"/"formatTime" input properties.
   */
  @Output() onDateTimeReceived = new EventEmitter<DatePickerEmission>()
  constructor() { }

  ngOnInit() { }


  public onEmissionFromInnerPicker(dateTimeSelected: DatePickerEmission): void {
    this.onDateTimeReceived.emit(dateTimeSelected);

  }

}
